import React, { useEffect, useState } from 'react';

export const SpellListFilterContext = React.createContext();

export const SpellListFilterProvider = ({ children }) => {
    const [ searchString, setSearchString ] = useState('');
    const [ preparedFilter, setPreparedFilter ] = useState(null);
    const [ schoolFilter, setSchoolFilter ] = useState(null);
    const [ levelFilter, setLevelFilter ] = useState([]);
    const [ damageTypeFilter, setDamageTypeFilter ] = useState([]);
    const [ componentFilter, setComponentFilter ] = useState({positive: [], negative: []});
    const [ tagFilter, setTagFilter ] = useState({positive: [], negative: []});
    const [ saveFilter, setSaveFilter ] = useState(null);
    const [ attackFilter, setAttackFilter ] = useState(null);
    const [ activeCount, setActiveCount ] = useState(0);

    useEffect(() => {
        setActiveCount(
             (!!schoolFilter ? 1 : 0)
             + (!!preparedFilter ? 1 : 0)
             + (!!saveFilter ? 1 : 0)
             + (!!attackFilter ? 1 : 0)
             + (levelFilter.length)
             + (damageTypeFilter.length)
             + (componentFilter?.positive.length)
             + (componentFilter?.negative.length)
             + (tagFilter?.positive.length)
             + (tagFilter?.negative.length)
        );
    }, [saveFilter, attackFilter, schoolFilter, preparedFilter, levelFilter, componentFilter, tagFilter, damageTypeFilter]);

    const clearFilters = () => {
        setSchoolFilter(null);
        setPreparedFilter(null);
        setSaveFilter(null);
        setAttackFilter(null);
        setLevelFilter([]);
        setDamageTypeFilter([]);
        setComponentFilter({positive: [], negative: []});
        setTagFilter({positive: [], negative: []});
        setActiveCount(0);
    };

    return (
        <SpellListFilterContext.Provider value={{ 
            searchString, setSearchString,
            schoolFilter, setSchoolFilter, 
            preparedFilter, setPreparedFilter,
            levelFilter, setLevelFilter,
            componentFilter, setComponentFilter,
            tagFilter, setTagFilter,
            damageTypeFilter, setDamageTypeFilter,
            attackFilter, setAttackFilter,
            saveFilter, setSaveFilter,
            activeCount, clearFilters
         }}>
             {children}
        </SpellListFilterContext.Provider>
    );
};
